import React, { useState } from 'react';
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { Button, Input } from 'edozvola-frontend-lib/dist/ui/components';
import { Label } from 'edozvola-frontend-lib/dist/ui';
import { initialCaseActRequestDescriptionModel } from 'app/edozvola/cases/case-acts/model/case-acts.model';
import { useFormik } from 'formik';
import { AutosizeTextArea } from 'app/shared/autosize-text-area/autosize-text-area';

interface CaseActRequestDescriptionModalProps {
  modalShown: boolean;
  setModalShown: any;
  onSubmit: any;
}

const CaseActRequestDescriptionModal = (props: CaseActRequestDescriptionModalProps) => {

  const formik = useFormik({
    initialValues: initialCaseActRequestDescriptionModel,
    onSubmit: values => {
      props.onSubmit(values.caseActRequestDescription);
      props.setModalShown(false);
    },
    validateOnMount: true,
    validateOnChange: true,
  });

  return (
    <Modal centered scrollable size={'xl'} isOpen={props.modalShown}>
      <ModalHeader>
        Izrada akta
      </ModalHeader>
      <ModalBody>
        <Row>
         <Col>
           <Label labelText={'Kratki opis zahtjeva'} />
           <AutosizeTextArea
             value={formik.values.caseActRequestDescription}
             maxLength={2048}
             onChange={e => formik.setFieldValue('caseActRequestDescription', e.target.value)}
           />
         </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button
        size={'lg'}
        label={'Odustani'}
        onClick={() => props.setModalShown(false)}
        color={'secondary'}
        />
        <Button
        size={'lg'}
        label={'Izradi dokument'}
        onClick={() => formik.handleSubmit()}
        color={'info'}
        />
      </ModalFooter>
    </Modal>
  );
};

export default CaseActRequestDescriptionModal;
